import { combineReducers, createStore } from "redux";
import users from "./users";
import tokens from "./tokens";
import github from "./github";
import profile from "./profile";
import userProfile from "./userProfile";
import congress from "./congress";
import applications from "./applications";
import permissions from "./permissions";
import { getCookie, setCookie } from "../utils/cookies";
import groupSpecialty from "./groupSpecialty";
import persona from "../packages/personalization-framework/reducers/reducer";
import { lmbc } from "../packages/derm-finder/reducers";
import specialtyOptions from "./specialty";
import tierOptions from "./tier";
import lmsCourseList from "./lmsCourseList";

const appReducer = combineReducers({
    users,
    tokens,
    profile,
    userProfile,
    applications,
    congress,
    permissions,
    github,
    groupSpecialty,
    persona,
    lmbc,
    specialtyOptions,
    tierOptions,
    lmsCourseList,
});

const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
        state = {};
        setTimeout(() => {
            window.location.reload();
        }, 10);
    }

    const cookie = getCookie("piap_jwt_token");
    if (cookie) {
        setCookie("piap_jwt_token", cookie);
        setCookie("piap_host_url", getCookie("piap_host_url"));
    }
    return appReducer(state, action);
};

export default createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
